module.exports = __webpack_public_path__ + "static/media/astro-bag.b005f4e7.png";